<template>
  <v-dialog v-model="dialog" scrollable :retain-focus="false" max-width="900px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        small
        :ripple="false"
        class="text-body-2 pl-0 non-text-transformation display-btn"
        :class="!canEditOffer && 'no-pointer'"
        v-bind="attrs"
        v-on="canEditOffer && on"
      >
        {{ $t('SHIPPING_HEADERS_WEIGHT') }}

        <v-icon v-if="canEditOffer" class="text-body-1 pl-1">mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h3 px-10 py-6 dialog-title">
        {{ $t('SHIPPING_WEIGHTS_MODAL_TITLE', { product: $t(`PRODUCT_${productId}`) }) }}
      </v-card-title>

      <v-divider />

      <v-card-text class="modal__container">
        <div class="pt-0">
          <div class="mb-3 d-flex justify-space-around">
            <div
              v-for="(group, iGroup) in groupedWeightList"
              :key="iGroup"
              class="d-flex flex-column"
            >
              <v-checkbox
                v-model="selectedWeightList"
                v-for="(weigth, iWeigth) in group"
                :key="iWeigth"
                :label="`${weigth} kg`"
                :value="weigth"
                hide-details
              />
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="d-flex justify-end pa-4">
        <div>
          <v-btn
            class="ml-4 link non-text-transformation"
            color="black"
            tile
            outlined
            @click="handleClose"
          >
            {{ $t('SHIPPING_MODAL_ACTIONS_CANCEL') }}
          </v-btn>

          <v-btn
            class="ml-4 link non-text-transformation"
            color="black"
            tile
            outlined
            @click="handleSetDefaultWeights"
          >
            {{ $t('SHIPPING_MODAL_ACTIONS_DEFAULT_WEIGHTS') }}
          </v-btn>

          <v-btn class="ml-4 link non-text-transformation" color="primary" tile @click="handleSave">
            {{ $t('SHIPPING_MODAL_ACTIONS_ADD') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sort } from '@/helpers/helpers'
import { mapActions, mapGetters } from 'vuex'
import { UPDATE_PRODUCT_CURRENT_WEIGHT_LIST } from '@/store/modules/offer/actions'

export default {
  name: 'UpdateSelectedWeightsDialog',
  props: ['productId', 'productWeightList', 'currentWeightList', 'standardWeightList'],
  data() {
    return {
      dialog: false,
      selectedWeightList: this.currentWeightList,
    }
  },
  computed: {
    ...mapGetters('offer', ['canEditOffer']),
    groupedWeightList() {
      const result = []
      const minNumPerColumn = Math.floor(this.productWeightList.length / 4)
      const remainder = this.productWeightList.length % 4
      let startIndex = 0
      let endIndex = 0
      for (let i = 0; i < 4; i++) {
        endIndex += remainder > i ? minNumPerColumn + 1 : minNumPerColumn
        result.push(this.productWeightList.slice(startIndex, endIndex))
        startIndex = endIndex
      }
      return result
    },
  },
  methods: {
    ...mapActions('offer', [UPDATE_PRODUCT_CURRENT_WEIGHT_LIST]),
    handleClose() {
      this.dialog = false
    },
    handleSetDefaultWeights() {
      this.selectedWeightList = [...this.standardWeightList]
    },
    handleSave() {
      const sortedWeightList = sort(this.selectedWeightList)

      this[UPDATE_PRODUCT_CURRENT_WEIGHT_LIST]({
        productId: this.productId,
        weightList: sortedWeightList,
      })

      this.dialog = false
    },
  },
}
</script>

<style scoped lang="scss">
.modal {
  &__container {
    height: rem(400);
  }
}
.no-pointer {
  cursor: initial;
}
</style>
